<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入名称" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="image" >
        <file-upload type="image" :defaultList="form.imageArr" :count="1" :imgSize="'160*160'"
                     @input="getImg($event, 'image')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="是否推荐" prop="isRecommend">
        <a-radio-group v-model="form.isRecommend">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="制作时长 分钟" prop="cookTime" >
        <a-input-number style="width: 200px" :min="0" v-model="form.cookTime" placeholder="请输入制作时长 分钟" />
      </a-form-model-item>
      <a-form-model-item label="食物分类" prop="categoryId" >
        <a-select v-model="form.categoryId">
          <a-select-option v-for="item in foodCategory" :value="item.id" :key='item.id'>{{item.dictLabel}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="食谱分类" prop="recipeId" >
        <a-select v-model="form.recipeId">
          <a-select-option v-for="item in foodRecipe" :value="item.id" :key='item.id'>{{item.dictLabel}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="食物类型" prop="type" >
          <a-radio-group v-model="form.type">
            <a-radio :value="1">绿灯</a-radio>
            <a-radio :value="2">黄灯</a-radio>
            <a-radio :value="3">红灯</a-radio>
          </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="基础千卡" prop="kilocalorie" >
        <a-input-number style="width: 200px" :min="0" v-model="form.kilocalorie" placeholder="请输入基础千卡" />
      </a-form-model-item>
      <a-form-model-item label="基础千焦" prop="kilojoule" v-if="form.kilojoule">
        <a-input-number disabled style="width: 200px" readOnly v-model="form.kilojoule" placeholder="请输入基础千焦" />
      </a-form-model-item>
      <a-form-model-item label="基础份量" prop="quantity" >
        <a-input-number style="width: 200px" :min="0" v-model="form.quantity" placeholder="请输入基础份量g" />
      </a-form-model-item>
      <a-form-model-item label="单位" prop="unit" >
        <a-input  v-model="form.unit" placeholder="请输入单位" />
      </a-form-model-item>
      <a-form-model-item label="基础蛋白质份量g" prop="proteinWeight" >
        <a-input-number style="width: 200px" :min="0" v-model="form.proteinWeight" placeholder="请输入基础蛋白质份量g" />
      </a-form-model-item>
      <a-form-model-item label="基础蛋白质含量百分比%" v-if="form.proteinRatio" prop="proteinRatio" >
        <a-input-number disabled style="width: 200px" readOnly v-model="form.proteinRatio" placeholder="请输入基础蛋白质含量百分比%" />%
      </a-form-model-item>
      <a-form-model-item label="基础碳水化合物份量g" prop="carbohydrateWeight" >
        <a-input-number style="width: 200px" :min="0" v-model="form.carbohydrateWeight" placeholder="请输入基础碳水化合物份量g" />
      </a-form-model-item>
      <a-form-model-item label="基础碳水化合物含量百分比%"  v-if="form.carbohydrateRatio" prop="carbohydrateRatio" >
        <a-input-number disabled style="width: 200px" readOnly v-model="form.carbohydrateRatio" placeholder="请输入基础碳水化合物含量百分比%" />%
      </a-form-model-item>
      <a-form-model-item label="基础脂肪份量g" prop="fatWeight" >
        <a-input-number style="width: 200px" :min="0" v-model="form.fatWeight" placeholder="请输入基础脂肪份量g" />
      </a-form-model-item>
      <a-form-model-item label="基础脂肪含量百分比%"  v-if="form.fatRatio" prop="fatRatio" >
        <a-input-number disabled style="width: 200px" readOnly v-model="form.fatRatio" placeholder="请输入基础脂肪含量百分比%" />%
      </a-form-model-item>

      <a-form-model-item label="相当于米饭份量" prop="ricePortion" >
        <a-input-number style="width: 200px" :min="0" v-model="form.ricePortion" placeholder="请输入相当于米饭份量" />
      </a-form-model-item>
      <a-form-model-item label="消耗需要步行距离" prop="walkingDistance" >
        <a-input-number style="width: 200px" :min="0" v-model="form.walkingDistance" placeholder="请输入消耗需要步行距离 km" />km
      </a-form-model-item>
      <a-form-model-item label="特点" prop="characteristic" >
        <a-input v-model="form.characteristic" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="食材" prop="foodMaterialList" >
        <a-button type="primary" @click="addMaterial()">
          <a-icon type="plus" />新增
        </a-button>
<!--        <div v-for="item in form.foodMaterialList" style="flex-direction: row">-->
<!--          名称：<a-input style="width: 200px" v-model="item.name"/>-->
<!--          份量：<a-input-number :min="1" style="width: 200px" v-model="item.quantity"/>g-->
<!--          <a @click="handleDelete(item.key,item)" >-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
<!--        </div>-->
        <a-table
          :loading="false"
          size="middle"
          rowKey="key"
          :columns="columns"
          :data-source="form.foodMaterialList"
          :pagination="false"
          :bordered="false"
        >
          <span slot="operation" slot-scope="text, record">
            <a @click="handleDelete(record.key,record)" >
              <a-icon type="delete" :style="{ color: 'red' }" />
              <span class="text-red">删除</span>
            </a>
          </span>
          <span slot="name" slot-scope="text, record">
            <a-input v-model:value="record.name"/>
          </span>
          <span slot="quantity" slot-scope="text, record">
            <a-input-number v-model:value="record.quantity" @blur="save(record,$event)"  :min="1"  />
          </span>
          <span slot="uint" slot-scope="text, record">
            <a-input v-model:value="record.uint"  @blur="save1(record,$event)" :min="1"  style="width: 80px;" />
          </span>
        </a-table>
      </a-form-model-item>
      <a-form-model-item label="做法" prop="practice" >
        <a-input v-model="form.practice" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="规格" prop="foodSkuList">
        <a-button type="primary" @click="addSku()">
          <a-icon type="plus" />新增
        </a-button>
        <a-table
          :loading="false"
          size="middle"
          rowKey="key"
          :columns="skuColumns"
          :data-source="form.foodSkuList"
          :pagination="false"
          :bordered="false"
        >
          <span slot="operation" slot-scope="text, record">
            <a @click="deleteSku(record.key,record)" >
              <a-icon type="delete" :style="{ color: 'red' }" />
              <span class="text-red">删除</span>
            </a>
          </span>
          <span slot="quantity" slot-scope="text, record">
            <a-input-number v-model:value="record.quantity" @blur="saveQuantity(record,$event)"  :min="1"  />g
          </span>
          <span slot="unit" slot-scope="text, record">
            <a-input v-model:value="record.unit" />
          </span>
<!--          <span slot="kilocalorie" slot-scope="text, record">-->
<!--            <a-input-number v-model:value="record.kilocalorie" @blur="saveKilocalorie(record,$event)"  :min="1" />千卡-->
<!--          </span>-->
<!--          <span slot="proteinWeight" slot-scope="text, record">-->
<!--            <a-input-number v-model:value="record.proteinWeight" @blur="saveProtein(record,$event)"  :min="1" />g-->
<!--          </span>-->
<!--          <span slot="carbohydrateWeight" slot-scope="text, record">-->
<!--            <a-input-number v-model:value="record.carbohydrateWeight" @blur="saveCarbohydrate(record,$event)"  :min="1"  />g-->
<!--          </span>-->
<!--          <span slot="fatWeight" slot-scope="text, record">-->
<!--            <a-input-number v-model:value="record.fatWeight"  @blur="saveFat(record,$event)"  :min="1"  />g-->
<!--          </span>-->
        </a-table>
      </a-form-model-item>
<!--      <a-form-model-item label="浏览量" prop="browserNum" >-->
<!--        <a-input v-model="form.browserNum" placeholder="请输入浏览量" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
// import { getFood, addFood, updateFood } from '@/api/food/food'
import {getDicts} from "@/api/system/dict/data";
import {guid} from "@/utils/ruoyi";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      foodCategory:[],
      foodRecipe:[],
      targetUnit:null,
      columns:[
        {
          title: '名称',
          dataIndex: 'name',
          ellipsis: true,
          scopedSlots: {customRender: 'name'},
          align: 'center'
        },
        {
          title: '份量',
          dataIndex: 'quantity',
          ellipsis: true,
          scopedSlots: {customRender: 'quantity'},
          align: 'center'
        },
        {
          title: '单位',
          dataIndex: 'uint',
          ellipsis: true,
          scopedSlots: {customRender: 'uint'},
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      skuColumns:[
        {
          title: '数量',
          dataIndex: 'quantity',
          ellipsis: true,
          scopedSlots: {customRender: 'quantity'},
          align: 'center'
        },
        {
          title: '单位',
          dataIndex: 'unit',
          ellipsis: true,
          scopedSlots: {customRender: 'unit'},
          align: 'center'
        },
        {
          title: '千卡',
          dataIndex: 'kilocalorie',
          ellipsis: true,
          // scopedSlots: {customRender: 'kilocalorie'},
          align: 'center'
        },
        {
          title: '蛋白质g',
          dataIndex: 'proteinWeight',
          ellipsis: true,
          // scopedSlots: {customRender: 'proteinWeight'},
          align: 'center'
        },
        {
          title: '碳水化合物g',
          dataIndex: 'carbohydrateWeight',
          ellipsis: true,
          // scopedSlots: {customRender: 'carbohydrateWeight'},
          align: 'center'
        },
        {
          title: '脂肪g',
          dataIndex: 'fatWeight',
          ellipsis: true,
          // scopedSlots: {customRender: 'fatWeight'},
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      // 表单参数
      form: {
        id: null,

        name: null,
        image: null,
        imageCount:1,
        imageArr:[],
        cookTime: null,

        categoryId: null,

        recipeId: null,

        type: null,

        kilocalorie: null,

        kilojoule: null,

        proteinWeight: null,

        proteinRatio: null,

        carbohydrateWeight: null,

        carbohydrateRatio: null,

        fatWeight: null,

        fatRatio: null,

        quantity: null,
        unit:null,

        ricePortion: null,

        walkingDistance: null,

        characteristic: null,

        foodMaterial: null,
        foodMaterialList:[],
        foodSkuList:[],
        practice: null,

        browserNum: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '图片不能为空', trigger: 'blur' }
        ],
        cookTime: [
          { required: true, message: '制作时长 分钟不能为空', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '食物分类 不能为空', trigger: 'blur' }
        ],
        recipeId: [
          { required: true, message: '食谱分类 不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '食物类型 不能为空', trigger: 'change' }
        ],
        kilocalorie: [
          { required: true, message: '基础千卡不能为空', trigger: 'blur' }
        ],
        kilojoule: [
          { required: true, message: '基础千焦不能为空', trigger: 'blur' }
        ],
        proteinWeight: [
          { required: true, message: '基础蛋白质份量g不能为空', trigger: 'blur' }
        ],
        proteinRatio: [
          { required: true, message: '基础蛋白质含量百分比%不能为空', trigger: 'blur' }
        ],
        carbohydrateWeight: [
          { required: true, message: '基础碳水化合物份量g不能为空', trigger: 'blur' }
        ],
        carbohydrateRatio: [
          { required: true, message: '基础碳水化合物含量百分比%不能为空', trigger: 'blur' }
        ],
        fatWeight: [
          { required: true, message: '基础脂肪份量g不能为空', trigger: 'blur' }
        ],
        fatRatio: [
          { required: true, message: '基础脂肪含量百分比%不能为空', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '基础份量不能为空', trigger: 'blur' }
        ],
        unit:[ { required: true, message: '单位不能为空', trigger: 'blur' }],
        ricePortion: [
          { required: true, message: '相当于米饭份量不能为空', trigger: 'blur' }
        ],
        walkingDistance: [
          { required: true, message: '消耗需要步行距离不能为空', trigger: 'blur' }
        ],
        characteristic: [
          { required: true, message: '特点不能为空', trigger: 'blur' }
        ],
        foodMaterial: [
          { required: true, message: '食材不能为空', trigger: 'blur' }
        ],
        practice: [
          { required: true, message: '做法不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initDict()
  },
  activated() {
    this.initDict()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    addMaterial(){
      const length = this.form.foodMaterialList.length
      this.form.foodMaterialList.push({
        key: length === 0 ? 0 : this.form.foodMaterialList[length - 1].key === undefined
          ? 0 :this.form.foodMaterialList[length - 1].key + 1,
        name:'',
        quantity:1,
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    addSku(){
      const length = this.form.foodSkuList.length
      this.form.foodSkuList.push({
        key: length === 0 ? 0 : this.form.foodSkuList[length - 1].key === undefined
          ? 0 :this.form.foodSkuList[length - 1].key + 1,
        id:null,
        quantity:1,
        kilocalorie:0,
        unit:'',
        proteinWeight:0,
        carbohydrateWeight:0,
        fatWeight:0
      })
    },

    deleteSku(key,record){
      // let index = this.form.foodSkuList.indexOf(row);
      // this.form.foodSkuList.splice(index,1)
      console.log(key,record)
      this.form.foodSkuList = this.form.foodSkuList.filter(item => item.key !== key)
    },
    handleDelete(key,record){
      console.log(key,record)
      // let index = this.form.foodMaterialList.indexOf(row);
      // this.form.foodMaterialList.splice(index,1)
      this.form.foodMaterialList = this.form.foodMaterialList.filter(item => item.key !== key)
    },
    save(record,o) {
      record.quantity =o.target.value
    },
    save1(record,o) {
      record.unit =o.target.value
    },
    saveQuantity(record,o){
      record.quantity = o.target.value
    },
    saveUnit(record,o){
      record.unit =  o.target.value
    },
    saveKilocalorie(record,o) {
      record.kilocalorieWeight =o.target.value
    },
    saveProtein(record,o) {
      record.proteinWeight =o.target.value
    },
    saveCarbohydrate(record,o) {
      record.carbohydrateWeight =o.target.value
    },
    saveFat(record,o) {
      record.fatWeight =o.target.value
    },

    initDict(){
      getDicts('food_category').then(res=>{
        this.foodCategory = res.data
      })
      getDicts('food_recipe').then(res=>{
        this.foodRecipe = res.data
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.targetUnit = null
      this.form = {
        id: null,
        name: null,
        image: null,
        imageCount:1,
        imageArr:[],
        isRecommend:0,
        cookTime: null,
        categoryId: null,
        recipeId: null,
        type: null,
        kilocalorie: null,
        kilojoule: null,
        proteinWeight: null,
        proteinRatio: null,
        carbohydrateWeight: null,
        carbohydrateRatio: null,
        fatWeight: null,
        fatRatio: null,
        quantity: null,
        unit:null,
        ricePortion: null,
        walkingDistance: null,
        characteristic: null,
        foodMaterial: null,
        foodMaterialList:[],
        foodSkuList:[],
        practice: null,
        browserNum: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.open = true
      this.formType = 2
      const id = row ? row.id : ids
      getFood({"id":id}).then(response => {
        this.form = response.data

        this.formTitle = '修改'
        // if(this.form.foodMaterial){
        //   this.form.foodMaterialList = JSON.parse(this.form.foodMaterial)
        //   this.form.foodMaterialList.forEach(item=>{
        //     item.key = parseInt(item.key)
        //     item.quantity = parseInt(item.quantity)
        //   })
        // }
        if(this.form.foodSkuList){
          let key=0;
          this.form.foodSkuList.forEach(item=>{
            if(key == 0){
              item.key = 0;
            }else{
              item.key = key+1
            }
            key++
          })
        }
        console.log(this.form.foodMaterialList)
        if(this.form.image){
          let that = this
          this.form.imageArr = []
          this.form.imageArr.push({
            uid: guid(8, 10),
            name: that.form.image,
            status: 'done',
            halfUrl: that.form.image,
            url: that.form.image,
            path: that.form.image
          })
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.form.foodMaterialList){
            this.form.foodMaterial = JSON.stringify(this.form.foodMaterialList)
          }
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateFood(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addFood(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
